import { render, staticRenderFns } from "./OnboardingStep3.vue?vue&type=template&id=50afd33c&"
import script from "./OnboardingStep3.vue?vue&type=script&lang=js&"
export * from "./OnboardingStep3.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingStep3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports